import { PopupTip } from '@uhc-tempo/components';

const PopUpJSX = ({ props }) => {
    return (
        <PopupTip
            icon="info"
            placement="top"
            iconVariant="outlined"
            data-testid={`${props}-popup-tip`}
        >
            {props}
        </PopupTip>
    );
};

export default PopUpJSX;
